<app-eca-modal-host [heading]="getHeadingFromOperative()"
                    (cancelClicked)="cancelClicked()"
                    editButtonText=""
                    editButtonIcon=""
                    (helpClicked)="showHelpClicked()"
                    [noButtonIcon]="['far', 'times']" [showExportToPDFButton]="true"
                    noButtonColour="transparent">
  <div class="container">
    <div class="container-fluid" id="dataToPrint">
      <div class="row" style="margin-top: 20px" *ngIf="showingHelp">
        <div class="col">
          <app-eca-help-alert [helpHtmlText]="easGuidanceHelpText" (helpCloseClicked)="showingHelp = false"></app-eca-help-alert>
        </div>
      </div>
      <div class="row" style="margin-top: 20px" *ngIf="asOfDate === '' && operatives?.length === 1">
        <div class="col ">
          <h3>{{companyName}} - {{lowVString}} guidance for {{operatives[0].getFullName()}}</h3>
        </div>
      </div>
      <div class="row" style="margin-top: 20px" *ngIf="asOfDate === '' && operatives?.length > 1 && companyName !== ''">
        <div class="col ">
          <h3>{{companyName}} - Current Operatives</h3>
        </div>
      </div>
      <div class="row" style="margin-top: 20px" *ngIf="asOfDate !== '' && operatives?.length === 1">
        <div class="col ">
          <h3>{{companyName}} - {{lowVString}} guidance for {{operatives[0].getFullName()}} as of {{asOfDate | date:'dd/MM/yyyy'}}</h3>
        </div>
      </div>
      <div class="row" style="margin-top: 20px" *ngIf="asOfDate !== '' && operatives?.length > 1">
        <div class="col ">
          <h3>{{companyName}} - Operatives as of {{asOfDate | date:'dd/MM/yyyy'}}</h3>
        </div>
      </div>
      <div *ngIf="!isQsRole">
        <div class="row" style="margin-top: 30px">
          <div class="col">
            <h4>Degree of Supervision (based on the risk matrix)</h4>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <app-supervision-matrix [allRisks]="allRisks"
                                    [riskMatrixEntries]="riskMatrixEntries"
                                    [allJobLevels]="allJobLevels"
                                    [operatives]="operatives">
            </app-supervision-matrix>
          </div>
        </div>
      </div>
      <div style="margin-top: 20px;">
        <h5 *ngIf="isQsRole">Operative is a Qualified Supervisor - carried out installation work requires no additional Assessment ({{lowVString}} Appendix 10)</h5>
        <h5 *ngIf="operatives?.length > 1"> Where installation work is carried out by someone registered as a QS there is no additional Assessment required ({{lowVString}} Appendix 10)</h5>
      </div>
      <div class="row" style="margin-top: 50px">
        <div class="col">
          <h4>Risk Matrix</h4>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <app-risk-matrix [allRisks]="allRisks" [riskMatrixEntries]="riskMatrixEntries" [allJobLevels]="allJobLevels" [operatives]="operatives"></app-risk-matrix>
        </div>
      </div>
      <div class="row" style="margin-top: 50px">
        <div class="col">
          <h4>Degree of Risk in the Electrotechnical Work {{lowVBS7671}}</h4>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <table>
            <tr>
              <th style="border-left-color: transparent; border-top-color: transparent"></th>
              <th>
                Installation Work Examples
                (Note: The Enterprise will be responsible for judging the degree of risk, this table is provided  for Guidance)
              </th>
              <th>Degree of Risk</th>
            </tr>

            <tr>
              <td rowspan="2">
                <span class="risk-matrix-cell-count" *ngIf="operatives.length>1 && !isHV" >{{ getOperativeNumbersInRiskRow(1) }}</span>
                <span class="risk-matrix-cell-count" *ngIf="operatives.length>1 && isHV">{{ getOperativeNumbersInRiskRow(4) }}</span>
              </td>
              <td *ngIf="!isHV" [ngClass]="getRiskCellClass(1)">
                Electrical work where the installation is isolated when not under the control of the installer e.g.
                <ul>
                  <li>First fix Electrotechnical work.</li>
                  <li>Second fix Electrotechnical work.</li>
                </ul>
              </td>
              <td *ngIf="isHV" [ngClass]="getRiskCellClass(4)">
                <!--Electrical work where the installation is isolated when not under the control of the installer e.g.
                <ul>
                  <li>First fix Electrotechnical work.</li>
                  <li>Second fix Electrotechnical work.</li>
                </ul>-->
                Working on an isolated system
              </td>
              <td *ngIf="!isHV" class="table-cell-title" [ngClass]="getRiskCellClass(1)">
                Low
              </td>
              <td *ngIf="isHV" class="table-cell-title" [ngClass]="getRiskCellClass(4)">
                Low
              </td>
            </tr>
            <tr>
              <td *ngIf="!isHV" [ngClass]="getRiskCellClass(1)">
                Electrical work defined as Minor Works in an unoccupied building – subject to safe isolation procedures documented and implemented
              </td>
              <td *ngIf="!isHV" class="table-cell-title" [ngClass]="getRiskCellClass(1)">
                Low
              </td>
              <!--<td *ngIf="isHV" [ngClass]="getRiskCellClass(4)">
                Electrical work defined as Minor Works in an unoccupied building – subject to safe isolation procedures documented and implemented
              </td>
              <td *ngIf="isHV" class="table-cell-title" [ngClass]="getRiskCellClass(4)">
                Low
              </td>-->
            </tr>

            <tr>
              <td>
                <span class="risk-matrix-cell-count" *ngIf="operatives.length>1 && !isHV">{{ getOperativeNumbersInRiskRow(2) }}</span>
                <span class="risk-matrix-cell-count" *ngIf="operatives.length>1 && isHV">{{ getOperativeNumbersInRiskRow(5) }}</span>
              </td>
              <td *ngIf="!isHV" [ngClass]="getRiskCellClass(2)">
                Electrical work defined as Minor Works in an occupied building – subject to safe isolation procedures documented and implemented
              </td>
              <td *ngIf="!isHV" class="table-cell-title" [ngClass]="getRiskCellClass(2)">
                Medium
              </td>
              <td *ngIf="isHV" [ngClass]="getRiskCellClass(5)">
                <!--Electrical work defined as Minor Works in an occupied building – subject to safe isolation procedures documented and implemented-->
                Off load switching & isolating
              </td>
              <td *ngIf="isHV" class="table-cell-title" [ngClass]="getRiskCellClass(5)">
                Medium
              </td>
            </tr>

            <tr>
              <td rowspan="2">
                <span class="risk-matrix-cell-count" *ngIf="operatives.length>1 && !isHV">{{ getOperativeNumbersInRiskRow(3) }}</span>
                <span class="risk-matrix-cell-count" *ngIf="operatives.length>1 && isHV">{{ getOperativeNumbersInRiskRow(6) }}</span>
              </td>
              <td *ngIf="!isHV" [ngClass]="getRiskCellClass(3)">
                All other <em>Electrotechnical work</em> whether or not it is subject to safe isolation procedures.
              </td>
              <td *ngIf="!isHV" class="table-cell-title" [ngClass]="getRiskCellClass(3)">High</td>
              <td *ngIf="isHV" [ngClass]="getRiskCellClass(6)">
                <!--All other <em>Electrotechnical work</em> whether or not it is subject to safe isolation procedures.-->
                Live working, On-load switching & isolating.
              </td>
              <td *ngIf="isHV" class="table-cell-title" [ngClass]="getRiskCellClass(6)">High</td>
            </tr>

            <tr>
              <td *ngIf="!isHV" [ngClass]="getRiskCellClass(3)">
                Electrical work – Periodic Inspection and Testing
              </td>
              <td *ngIf="!isHV" class="table-cell-title" [ngClass]="getRiskCellClass(3)">High</td>
              <!--<td *ngIf="isHV" [ngClass]="getRiskCellClass(6)">
                Electrical work – Periodic Inspection and Testing
              </td>
              <td *ngIf="isHV" class="table-cell-title" [ngClass]="getRiskCellClass(6)">High</td>-->
            </tr>
          </table>
        </div>
      </div>
      <div class="row" style="margin-top: 50px">
        <div class="col">
          <h4>Level of Operative Appointed</h4>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <table>
            <tr>
              <th style="border-left-color: transparent; border-top-color: transparent"></th>
              <th>Operative Level</th>
              <th>Guidance</th>
            </tr>
            <tr>
              <td>
                <span class="risk-matrix-cell-count" *ngIf="operatives.length>1 && !isHV">{{ getOperativeNumbersInJobLevelRow(1) }}</span>
                <span class="risk-matrix-cell-count" *ngIf="operatives.length>1 && isHV">{{ getOperativeNumbersInJobLevelRow(4) }}</span>
              </td>
              <td class="table-cell-title" *ngIf="!isHV" [ngClass]="getJobLevelCellClass(1)">
                Level 1
              </td>
              <td class="table-cell-title"*ngIf="isHV" [ngClass]="getJobLevelCellClass(4)">
                Level 1 
              </td>
              <td *ngIf="!isHV" [ngClass]="getJobLevelCellClass(1)">
                Operatives would be <em>Instructed persons (electrically)</em> who would generally be apprentices, labourers, electrician’s mates or electrical improvers – and who under the supervision of a <em>skilled person (electrically)</em>,
                could be able to install wiring systems. Others that fall within this category are career changers who may have training and/or qualifications but lack experience.
              </td>
              <td *ngIf="isHV" [ngClass]="getJobLevelCellClass(4)">
                Operatives would be instructed with a degree of competence in high voltage electrical work and safety, but would not be classed as skilled.  Examples would include apprentices, improvers and mates etc.
              </td>
            </tr>
            <tr>
              <td>
                <span class="risk-matrix-cell-count" *ngIf="operatives.length>1 && !isHV">{{ getOperativeNumbersInJobLevelRow(2) }}</span>
                <span class="risk-matrix-cell-count" *ngIf="operatives.length>1 && isHV">{{ getOperativeNumbersInJobLevelRow(5) }}</span>
              </td>
              <td class="table-cell-title" *ngIf="!isHV" [ngClass]="getJobLevelCellClass(2)">
                Level 2
              </td>
              <td class="table-cell-title" *ngIf="isHV" [ngClass]="getJobLevelCellClass(5)">
                Level 2 
              </td>
              <td *ngIf="!isHV" [ngClass]="getJobLevelCellClass(2)">
                Operatives would be <em>Instructed persons (electrically)</em> who are experienced, trusted electrical installers who can carry out Electrotechnical work efficiently and in
                accordance with the current BS 7671 and Building Regulations/Standards and can therefore be expected mostly to work without the need of close and detailed supervision.
              </td>
              <td *ngIf="isHV" [ngClass]="getJobLevelCellClass(5)">
                Operatives would be skilled and competent in high voltage electrical work and safety.
                Authorised Persons or equivalent and suitably skilled and competent in the area of work they undertake.
              </td>
            </tr>
            <tr>
              <td>
                <span class="risk-matrix-cell-count" *ngIf="operatives.length>1 && !isHV">{{ getOperativeNumbersInJobLevelRow(3) }}</span>
                <span class="risk-matrix-cell-count" *ngIf="operatives.length>1 && isHV ">{{ getOperativeNumbersInJobLevelRow(6) }}</span>
              </td>
              <td class="table-cell-title" *ngIf="!isHV" [ngClass]="getJobLevelCellClass(3)">
                Level 3
              </td>
              <td class="table-cell-title" *ngIf="isHV" [ngClass]="getJobLevelCellClass(6)">
                Level 3 
              </td>
              <td *ngIf="!isHV" [ngClass]="getJobLevelCellClass(3)">
                Operatives would be considered as <em>Skilled persons (electrically)</em> who possess practical, theoretical and electrical engineering skills,
                experience and knowledge with adequate technical supervisory experience comparable to that of QS.
              </td>
              <td *ngIf="isHV" [ngClass]="getJobLevelCellClass(6)">
                Operatives would be highly skilled in and competent in high voltage electrical work and safety.
                Senior Authorised Persons or equivalent and suitably skilled and competent in the area of work they undertake.
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</app-eca-modal-host>
